/**
 * Provides MUI theme derived from catalogue settings (IndexedDB).
 * Listens for catalogue-settings-changed so theme updates when user saves settings.
 */

import type React from 'react';
import { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { loadEffectiveSettings } from '../services/db';
import { createThemeFromSettings, defaultTheme } from './themeFromSettings';

export const ThemeFromSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState(() => defaultTheme);

  useEffect(() => {
    // Synced settings + the user's local branding override, merged.
    const apply = () => loadEffectiveSettings().then(s => setTheme(createThemeFromSettings(s)));
    apply();
    window.addEventListener('catalogue-settings-changed', apply);
    return () => window.removeEventListener('catalogue-settings-changed', apply);
  }, []);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
